"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeTypeVarsContext = void 0;
const util_1 = require("../../util");
const builders_1 = require("./builders");
function freeTypeVarsScheme(scheme) {
    return util_1.difference(builders_1.freeTypeVars(scheme.type), new Set(scheme.bound));
}
function freeTypeVarsContext(context) {
    return Object.values(context)
        .map(freeTypeVarsScheme)
        .reduce(util_1.union, new Set());
}
exports.freeTypeVarsContext = freeTypeVarsContext;
//# sourceMappingURL=helpers.js.map